import {base} from '../../../models/base';
import { fromJS } from "immutable";

export default {
  namespace: 'contact',
  state: {},
  reducers: Object.assign(
    base,
    {
    }
  )
};



// WEBPACK FOOTER //
// ./src/pages/contact/models/contact.js